// Initialize Sentry BEFORE anything else
import { initSentry } from './utils/sentry';
initSentry();

// Initialize i18n for multi-language support
import './i18n';

// Setup CSRF protection interceptor
import { setupCsrfInterceptor } from './hooks/useCsrf';
setupCsrfInterceptor();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
